(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function(){function s(r){var w=document.createTreeWalker(r,NodeFilter.SHOW_TEXT),a=[];while(w.nextNode()){a.push(w.currentNode)}for(var i=0;i<a.length;i++){var n=a[i];if(n.nodeValue.trim()==='DDS Tooning'&&n.parentNode&&!n.parentNode.classList.contains('dds-hero-tooning')){var e=document.createElement('span');e.className='dds-hero-tooning';e.style.color='#FF6A00';e.textContent='Tooning';n.parentNode.insertBefore(document.createTextNode('DDS '),n);n.parentNode.insertBefore(e,n);n.parentNode.removeChild(n);return true}}return false}function r(){var h=document.querySelectorAll('h2');for(var j=0;j<h.length;j++){if(h[j].textContent.trim()==='DDS Tooning'){s(h[j])}}}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',r)}else{r()}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
